import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DOCUMENT_STATUS } from '../../../../constraints';
import * as formatters from '../../../../formatters';
import { useConfigContext } from '../../../Config/hooks/useConfig';

// Components
import * as Styled from './styled';
import { ActionButtons } from './components';
import { CopiedInfo } from '../../../../components';
import { Grid } from 'billon-ui';

const { Row } = Grid;

const DailyReportTableDetails = ({ record, handleCreate, handleDelete }) => {
  const { enableActiveDelivery } = useConfigContext();

  if (!record.documentBlockchainAddress && !record.jobId) {
    return null;
  }

  return (
    <Styled.DocumentInfo>
      <Row noGutters margin={0}>
        <Styled.Col lg={enableActiveDelivery ? 4 : 5}>
          <CopiedInfo
            label={'Blockchain address'}
            alt={'Document does not yet have a blockchain address'}
            value={record?.documentBlockchainAddress}
            emphasisedValue={true}
            valuePlacedUnder
          />
        </Styled.Col>
        <Styled.Col lg={enableActiveDelivery ? 3 : 2}>
          {enableActiveDelivery && (
            <>
              <label className="large">
                <FormattedMessage
                  id="e-Delivery Status"
                  defaultMessage="e-Delivery Status"
                />{' '}
                :
              </label>
              <span className="status-span">
                <FormattedMessage
                  id="Confirmation of reading"
                  defaultMessage="Confirmation of reading"
                />
              </span>
              <br />
              <span>
                <FormattedMessage id="Date" defaultMessage="Date" />:{' '}
                {formatters.momentFormatter(new Date(2021, 3, 16, 17, 0, 0))}
              </span>
            </>
          )}
        </Styled.Col>
        <Styled.Col lg={5} className="info-col">
          {record.status !== DOCUMENT_STATUS.NOT_AVAILABLE && (
            <ActionButtons
              record={record}
              onDeleteDocument={handleDelete}
              onPublishDocument={handleCreate}
            />
          )}
        </Styled.Col>
      </Row>
    </Styled.DocumentInfo>
  );
};

export default DailyReportTableDetails;
